import { useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { LocaleContext } from "contexts"

const query = graphql`
  query useTranslations {
    rawData: allFile(filter: { sourceInstanceName: { eq: "translations" } }) {
      edges {
        node {
          name
          translations: childTranslationsJson {
            helpdeskLink
            seoTitleApp
            basePrice
            partnerPrice
            currency
            normalPrice
            yearShort
            monthShort
            personShortSingle
            personShortPlural
            blogTitle
            coverTitle
            coverSubTitle1
            coverSubTitle2
            buttonBuy
            buttonLogin
            buttonLoginHelp
            buttonOpenVideo
            buttonMore
            statsSectionTitle
            statsSectionDescription
            statsSectionData1
            statsSectionData2
            statsSectionData3
            statsSectionMainText
            statsSectionLink
            helpSectionStats
            helpSectionStatsSource
            helpSectionLockStats
            helpSectionLockNumber
            helpSectionListTitle
            helpSectionListItems
            helpSectionButton
            platformsSectionTitle
            platformsSectionText1
            platformsSectionText2
            platformsSectionText3
            platformsSectionText4
            platformsIconPlus
            platformsGuideLink
            orderSectionTitle
            orderSectionSubtitle
            orderSectionNormalPrice
            orderSectionPriceComment
            orderSectionPriceAsteriskText
            orderSectionButton
            orderSectionListTitle
            orderSectionListElement1
            orderSectionListElement2
            orderSectionListElement3
            orderSectionListElementLink
            orderSectionListElement4
            orderSectionListElement5
            orderSectionListElement6
            orderModalTitle
            orderModalPriceComment
            orderModalDescription
            orderModalProductName
            orderModalPriceTotal
            orderModalTerms1
            orderModalTerms2
            orderModalTerms3
            orderModalTerms4
            orderModalButton
            orderModalTermsError1
            orderModalTermsError2
            orderModalTermsError3
            orderModalTermsError4
            orderModalTermsError5
            orderModalInvoiceRequest1
            orderModalInvoiceRequestLink
            orderModalInvoiceRequest2
            orderModalInvoiceRequest3
            mediaSectionTitle
            mediaSectionButton
            mediaPageDescription
            mediaFeaturedCoverage
            mediaMoreCoverage
            mediaReadArticle
            mediaArticles
            mediaNoArticles
            mediaCheckBackSoon
            menuLinkHome
            menuLinkApp
            menuLinkAboutUs
            menuLinkMedia
            menuLinkBlog
            menuLinkPublications
            menuLinkWebinar
            menuLinkCourses
            menuLinkHelpdesk
            menuLinkPricing
            menuLinkCountry
            menuLinkParents
            menuLinkSomeUser
            menuLinkInfluencers
            menuLinkMunicipal
            menuLinkPrivacyPolicy
            menuLinkTermsOfService
            menuLinkWebshopOrderTerms
            menuLinkWebshopPrivacyTerms
            menuLinkLegal
            menuLinkTurvaopasTiktok
            menuLinkCookiePrefs
            menuLinkSchoolMain
            menuLinkSchoolTrainings
            menuLinkSchoolLessons
            menuLinkCompaniesMain
            menuLinkCompaniesTrainings
            menuLinkCompaniesOnboarding
            menuLinkCompaniesMainFull
            menuLinkCompaniesTrainingsFull
            menuLinkSchoolsOnboarding
            menuLinkParentsLessons
            page404Title
            page404Description
            pageMediaTitle
            pageOrderCompletedButton
            pageOrderCompletedTitle
            pageOrderCompletedHeader
            pageOrderCompletedPartner
            pageOrderCompletedSubHeader
            pageOrderCompletedDescription
            pageAppHeader
            pageAppSubheader
            pageAppCodeNegativeHeader
            pageAppCodeNegativeText
            pageAppCodeNegativeButton
            pageAppSometurvaHeading
            pageAppSometurvaDescription
            pageAppProHeading
            pageAppProDescription
            pageAppPricingLink
            functionalCookieBannerText
            functionalCookieBannerExplainer
            functionalCookieBannerButtonAccept
            functionalCookieBannerButtonReject
            cookieBannerTitle
            cookieBannerText1
            cookieBannerText2
            cookieBannerButtonMore
            cookieBannerButtonAcceptAll
            cookieBannerButtonRejectAll
            cookieBannerEssentialTitle
            cookieBannerEssentialDescription
            cookieBannerEssentialAlwaysActive
            cookieBannerFunctionalTitle
            cookieBannerFunctionalDescription
            cookieBannerAnalyticsTitle
            cookieBannerAnalyticsDescription
            cookieBannerButtonLess
            cookieBannerButtonAccept
            cookieBannerButtonReject
            cookieBannerButtonSave
            cookieBannerLinkText
            pdfPrivacyPolicyLink
            pdfShopTermsLink
            cookiePolicyLink
            privacyPolicyLink
            blogOrderSectionHeader
            blogOrderSectionSubheader
            blogOrderSectionButton
            blogNoPosts
            blogAllPosts
            teamText1
            teamText2
            teamText3
            teamText4
            teamText5
            teamText6
            teamCallout1
            teamHeading1
            teamHeading2
            teamHeading3
            teamHeading4
            teamLocation1
            teamLocation2
            teamRecruitName
            teamRecruitPosition
            teamRecruitLinkHref
            teamRecruitLinkText
            parentalTitle1
            parentalTitle2
            parentalTitle3
            parentalDescription
            parentalHeroButton
            parentalFeaturesTitle1
            parentalFeatures1_1
            parentalFeatures1_2
            parentalFeatures1_3
            parentalFeaturesTitle2
            parentalFeatures2_1
            parentalFeatures2_2
            parentalFeatures2_3
            parentalFeedbackTitle
            parentalFeedbackSubitle
            parentalFeedback1_Review
            parentalFeedback1_Author
            parentalFeedback1_AboutAuthor
            parentalFeedback2_Review
            parentalFeedback2_Author
            parentalFeedback2_AboutAuthor
            parentalFeedback3_Review
            parentalFeedback3_Author
            parentalFeedback3_AboutAuthor
            parentalOrderTitle
            parentalOrderPriceComment
            parentalOrderBestFeature1
            parentalOrderBestFeature2
            parentalOrderBestFeature3
            parentalMediaTitle
            parentalMediaQuote1
            parentalMediaQuote2
            parentalMediaQuote3
            subscribeHeader
            subscribeHeaderSchool
            subscribeButton
            subscribeEmailPlaceholder
            subscribePrivacyPolicy1
            subscribePrivacyPolicy2
            ourCustomers
            faqTitle
            faqSubtitle1
            faqSubtitleLink
            faqSubtitle2
            bannerShort
            bannerLong
            bannerButton
            bannerLink
            openWebappSmall
            openWebappLarge
            howItWorksTitle
            howItWorksFeature1Title
            howItWorksFeature1_1
            howItWorksFeature1_2
            howItWorksFeature1_3
            howItWorksFeature1_4
            howItWorksFeature2Title
            howItWorksFeature2_1
            howItWorksFeature2_2
            howItWorksFeature3Title
            howItWorksFeature3_1
            howItWorksFeature4Title
            howItWorksFeature4_1
            howItWorksFeature4_2
            howItWorks2Feature1Title
            howItWorks2Feature1Text
            howItWorks2Feature2Title
            howItWorks2Feature2Text
            howItWorks2Feature3Title
            howItWorks2Feature3Text
            influencerTitle1
            influencerTitle2
            influencerTitle3
            influencerDescription
            influencerHeroButton1
            influencerHeroButton2
            influencerFeedbackTitle
            influencerFeedbackSubitle
            influencerFeedback1_Title
            influencerFeedback1_Review
            influencerFeedback1_Author
            influencerFeedback1_AboutAuthor
            influencerFeedback2_Title
            influencerFeedback2_Review
            influencerFeedback2_Author
            influencerFeedback2_AboutAuthor
            influencerFeedback3_Title
            influencerFeedback3_Review
            influencerFeedback3_Author
            influencerFeedback3_AboutAuthor
            influencerFeaturesTitle1
            influencerFeatures1_1
            influencerFeatures1_2
            influencerFeatures1_3
            influencerFeatures1_4
            influencerHowDoWeHelpTitle
            influencerHowDoWeHelp1Title
            influencerHowDoWeHelp1Text
            influencerHowDoWeHelp2Title
            influencerHowDoWeHelp2Text
            influencerHowDoWeHelp3Title
            influencerHowDoWeHelp3Text
            influencerPricingTitle
            influencerPeopleTitle
            influencerPeopleText1
            influencerPeopleText2
            generalInfluencerTitle2
            generalInfluencerFeaturesTitle1
            generalInfluencerFeatures1_3
            generalInfluencerHowDoWeHelp2Text
            generalInfluencerPeopleText2
            generalInfluencersMediaTitle
            generalInfluencersMediaQuote1
            generalInfluencersMediaQuote2
            generalInfluencersMediaQuote3
            generalInfluencersMediaQuote4
            generalInfluencersMediaQuote1Link
            generalInfluencersMediaQuote2Link
            generalInfluencersMediaQuote3Link
            generalInfluencersMediaQuote4Link
            generalInfluencersPlanTitle
            generalInfluencersPlanText1
            generalInfluencersPlanText2
            generalInfluencersPlanLink
            mainRequestDemoButton
            appointmentLink
            hrTitle1
            hrTitle2
            hrTitle3
            hrHighlight
            hrDescription
            hrHeroButton1
            hrHeroButtonComment
            hrHeroButton2
            hrFeaturesTitle1
            hrFeatures1_1
            hrFeatures1_2
            hrFeatures1_3
            hrFeatures1_4
            hrFeatures1_5
            hrHowDoWeHelpTitle
            hrHowDoWeHelp1Title
            hrHowDoWeHelp1Text
            hrHowDoWeHelp2Title
            hrHowDoWeHelp2Text
            hrHowDoWeHelp3Title
            hrHowDoWeHelp3Text
            hrHowDoWeHelp4Title
            hrHowDoWeHelp4Text
            hrHowDoWeHelpButton
            hrHowDoWeHelpButtonComment
            hrWhistleblowingTitle
            hrWhistleblowingSubtitle
            hrWhistleblowingText1
            hrWhistleblowingText2
            hrWhistleblowingButton
            hrWhistleblowingButtonComment
            hrCaseQuoteTitle
            hrCaseQuote1Title
            hrCaseQuote1Text
            hrCaseQuote2Title
            hrCaseQuote2Text
            hrCaseQuote3Title
            hrCaseQuote3Text
            hrFeedbackTitle
            hrFeedbackSubitle
            hrFeedback1_Title
            hrFeedback1_Review
            hrFeedback1_Author
            hrFeedback1_AboutAuthor
            hrFeedback2_Title
            hrFeedback2_Review
            hrFeedback2_Author
            hrFeedback2_AboutAuthor
            hrFeedback3_Review
            hrFeedback3_Author
            hrFeedback3_AboutAuthor
            hrRequestDemoTitle
            hrDemoFeature1
            hrDemoFeature2
            hrDemoFeature3
            pricingTierInfluencerOneCaseName
            pricingTierInfluencerOneCasePrice
            pricingTierInfluencerOneCasePricePartner
            pricingTierInfluencerOneCaseDuration
            pricingTierInfluencerOneCaseDescription
            pricingTierInfluencerSubscriptionName
            pricingTierInfluencerSubscriptionPrice
            pricingTierInfluencerSubscriptionPricePartner
            pricingTierInfluencerSubscriptionDuration
            pricingTierInfluencerSubscriptionDescription
            pricingTierBaseOneCaseName
            pricingTierBaseOneCasePrice
            pricingTierBaseOneCaseDuration
            pricingTierBaseOneCaseDescription
            pricingTierBaseSubscriptionName
            pricingTierBaseSubscriptionPrice
            pricingTierBaseSubscriptionDuration
            pricingTierBaseSubscriptionDescription
            pricingTierParentalOneCaseName
            pricingTierParentalOneCasePrice
            pricingTierParentalOneCaseDuration
            pricingTierParentalOneCaseDescription
            pricingTierParentalSubscriptionName
            pricingTierParentalSubscriptionPrice
            pricingTierParentalSubscriptionDuration
            pricingTierParentalSubscriptionDescription
            tierFeature1
            tierFeature2
            tierFeature3
            tierFeature4
            tierFeature5
            vatIncluded
            caseQuoteTitle
            caseQuote1Title
            caseQuote1Text
            caseQuote2Title
            caseQuote2Text
            caseQuote3Title
            caseQuote3Text
            footerContact
            footerContactButton
            dashboard_socialmediaChannels1
            dashboard_socialmediaChannels2
            dashboard_descending
            dashboard_histogramSorted
            dashboard_crimeCategories
            dashboard_defamation
            dashboard_harassingCommunication
            dashboard_violatingPersonalPrivacy1
            dashboard_violatingPersonalPrivacy2
            dashboard_stalking
            dashboard_menace
            dashboard_illicitObservation1
            dashboard_illicitObservation2
            dashboard_identityTheft1
            dashboard_identityTheft2
            dashboard_other
            dashboard_criticalCases
            dashboard_criticalCase1
            dashboard_criticalCase2
            dashboard_criticalCase3
            dashboard_positive
            dashboard_negative
            dashboard_trusted
            dashboard_valued
            dashboard_good
            dashboard_understanding
            dashboard_down
            dashboard_anxious
            dashboard_stressed
            dashboard_howYourEmployeesAreFeeling
            dashboard_onlineWellbeingPulse1
            dashboard_onlineWellbeingPulse2
            dashboard_notACrime
            dashboard_crime
            dashboard_ofCases
            dashboard_crimeOrNot
            dashboard_reportedCases
            dashboard_cases
            dashboard_protectedEmployees
            dashboard_people
            dashboard_statisticsForLast7Days
            webinarTitle
            webinarRequestText1
            webinarRequestText2
            webinarRequestLinkText
            webinarEmptyText
            webinarSubscribeButton
            blogTimeToRead
            blogMinute
            blogMinutes
            segmentCardParentsName
            segmentCardParentsDescription
            segmentCardParentsButton
            segmentCardInfluencersName
            segmentCardInfluencersDescription
            segmentCardInfluencersButton
            segmentCardSocialMediaUsersName
            segmentCardSocialMediaUsersDescription
            segmentCardSocialMediaUsersButton
            segmentCardMunicipalName
            segmentCardMunicipalDescription
            segmentCardMunicipalButton
            segmentCardPriceFrom
            allSomeGuidesTitle
            allSomeGuidesSubtitle
            municipalPageTitle
            municipalPageDescription
            municipalTitle1
            municipalTitle2
            municipalTitle3
            municipalDescription
            municipalHeroButton
            municipalHeroButtonComment
            municipalHeroLanguages
            municipalQuote1Title
            municipalQuote1Text
            municipalQuote1Name
            municipalQuote2Title
            municipalQuote2Text
            municipalQuote2Name
            municipalQuote3Title
            municipalQuote3Text
            municipalQuote3Name
            municipalQuestion1Title
            municipalQuestion1Text1
            municipalQuestion1Text2
            municipalQuestion1Text3
            municipalQuestion2Title
            municipalQuestion2Text
            municipalActivationTitle
            municipalActivationSubtitle
            municipalActivation1_1
            municipalActivation1_2
            municipalActivation2_1
            municipalActivation2_2
            municipalActivation2_3
            municipalActivation3_1
            municipalActivation3_2
            municipalActivation3_3
            municipalActivation4
            municipalProgramTitle
            municipalProgramText
            municipalProgramLink
            municipalOver24Text
            videoPageTitle
            otherSectionVideo1Title
            otherSectionVideo1Description
            videoSection1Video1Title
            otherSectionVideo1Link
            otherSectionVideo2Title
            otherSectionVideo2Description
            videoSection2Video1Title
            otherSectionVideo2Link
            videoSection3Title
            videoSection3Description
            videoSection3Video1Title
            videoSection3Video1Link
            videoSection3Video2Title
            videoSection3Video2Link
            webinarRecordingTitle
            webinarRecordingText1
            webinarRecordingText2
            webinarRecordingLink
            proHowDoWeHelpTitle
            proStepsItem1
            proStepsItem2
            proStepsItem3
            schoolHeroTitle
            schoolHeroHighlight
            schoolHeroDescription1
            schoolHeroDescription2
            schoolHowDoWeHelpTitle
            schoolHelpListItem1
            schoolHelpListItem2
            schoolHelpListItem3
            schoolCaseQuoteTitle
            schoolCaseQuote1Title
            schoolCaseQuote1Text
            schoolCaseQuote2Title
            schoolCaseQuote2Text
            schoolCaseQuote3Title
            schoolCaseQuote3Text
            schoolFeedbackTitle
            schoolFeedback1_Review
            schoolFeedback1_Author
            schoolFeedback1_AboutAuthor
            schoolFeedback2_Review
            schoolFeedback2_Author
            schoolFeedback2_AboutAuthor
            schoolFeedback3_Review
            schoolFeedback3_Author
            schoolFeedback3_AboutAuthor
            schoolDemoTitle
            schoolDemoFeature1
            schoolDemoFeature2
            schoolDemoFeature3
            schoolCommunitiesTitle
            schoolCommunitiesStudentsLabel
            schoolCommunitiesStudents1
            schoolCommunitiesStudents2
            schoolCommunitiesStudents3
            schoolCommunitiesTeachersLabel
            schoolCommunitiesTeachers1
            schoolCommunitiesTeachers2
            schoolCommunitiesTeachers3
            schoolCommunitiesManagerLabel
            schoolCommunitiesManager1
            schoolCommunitiesManager2
            schoolCommunitiesManager3
            schoolWebinarTitle
            schoolWebinarRequestText1
            schoolWebinarRequestText2
            schoolWebinarRequestLinkText
            schoolWebinarEmptyText
            schoolFactGirls1
            schoolFactGirls2
            schoolFactGirls3
            schoolFactGirlsPercentage
            schoolFactStudents1
            schoolFactStudents2
            schoolFactStudents3
            schoolFactStudentsPercentage
            schoolsInfo1Title
            schoolsInfo1Text
            schoolsInfo1Highlight
            schoolsInfo1SmallText
            schoolsInfo2Title
            schoolsInfo2Text
            schoolsInfo2Highlight
            schoolsInfo2SmallText
            schoolsPdfTitle
            schoolsPdfSubtitle
            schoolsPdfFormJobOptions
            schoolsPdfFormButton
            schoolsPdfErrorGeneral
            schoolsPdfErrorUserExist
            schoolsPdfErrorContactUs
            schoolsPdfSuccess
            navMenuPersonal
            navMenuSchools
            navMenuCompanies
            navMenuOther
            navMenuOtherCompany
            navMenuOtherResources
            navMenuDataProtection
            navMenuBlog
            navMenuBlogAll
            navMenuProductCardMore
            legalLastUpdated
            legalPageName
            proStepsItem1Title
            proStepsItem2Title
            proStepsItem3Title
            blogSectionTitle
            testimonial1Id
            testimonial1Title
            testimonial1Description
            testimonial1PersonName
            testimonial1PersonDescription
            testimonial1FactLarge
            testimonial1FactSmall
            testimonial12Id
            testimonial2Title
            testimonial2Description
            testimonial2PersonName
            testimonial2PersonDescription
            testimonial2FactLarge
            testimonial2FactSmall
            testimonialEn1Id
            testimonialEn1Title
            testimonialEn1Description
            testimonialEn1PersonName
            testimonialEn1PersonDescription
            testimonialEn1FactLarge
            testimonialEn1FactSmall
            testimonialEn12Id
            testimonialEn2Title
            testimonialEn2Description
            testimonialEn2PersonName
            testimonialEn2PersonDescription
            testimonialEn2FactLarge
            testimonialEn2FactSmall
            testimonialReadMore
            protectionTitle
            protectionPreventShort
            protectionPreventLong
            protectionPreventContactName
            protectionPreventContactPosition
            protectionPreventContactEmail
            protectionProtectShort
            protectionProtectLong
            protectionProtectContactName
            protectionProtectContactPosition
            protectionProtectContactEmail
            protectionImpactShort
            protectionImpactLong
            protectionImpactContactName
            protectionImpactContactPosition
            protectionImpactContactEmail
            protectionPreventHighlight
            protectionProtectHighlight
            protectionImpactHighlight
            protectionReadMore
            problemsProTitle
            problemsPro1Title
            problemsPro1Description
            problemsPro2Title
            problemsPro2Description
            problemsPro3Title
            problemsPro3Description
            problemsPro4Title
            problemsPro4Description
            problemsPro5Title
            problemsPro5Description
            problemsMainTitle
            problemsMain1Title
            problemsMain1Description
            problemsMain2Title
            problemsMain2Description
            problemsMain3Title
            problemsMain3Description
            problemsMain4Title
            problemsMain4Description
            problemsMain5Title
            problemsMain5Description
            impactTitle
            impact1Title
            impact1Description
            impact2Title
            impact2Description
            impact3Title
            impact3Description
            impact4Title
            impact4Description
            impact5Title
            impact5Description
            impact6Title
            impact6Description
            serviceProTitle
            servicePro1Heading
            servicePro1Subheading
            servicePro1Description
            servicePro2Heading
            servicePro2Subheading
            servicePro2Description
            servicePro3Heading
            servicePro3Subheading
            servicePro3Description
            servicePro4Heading
            servicePro4Subheading
            servicePro4Description
            serviceEnTitle
            serviceEn1Heading
            serviceEn1Subheading
            serviceEn1Description
            serviceEn2Heading
            serviceEn2Subheading
            serviceEn2Description
            serviceEn3Heading
            serviceEn3Subheading
            serviceEn3Description
            serviceEn4Heading
            serviceEn4Subheading
            serviceEn4Description
            mainHero1
            mainHero2
            mainHero3
            mainHeroDescription
            mainHeroDescriptionHighlight
            whyUsTitle
            whyUsText
            whyUsStat1Percentage
            whyUsStat1Description
            whyUsStat2Percentage
            whyUsStat2Description
            whyUsStat3Percentage
            whyUsStat3Description
            whyUsStat4Percentage
            whyUsStat4Description
            whyUsSources
            situationsTitle
            situation1Title
            situation1Description
            situation2Title
            situation2Description
            situation3Title
            situation3Description
            situation4Title
            situation4Description
            situation5Title
            situation5Description
            valuePropositionConceptualTitle
            valuePropositionConceptualText
            valuePropositionConceptual1
            valuePropositionConceptual2
            valuePropositionConceptual3
            valuePropositionConceptual4
            valuePropositionFoundationTitle
            valuePropositionFoundationText1
            valuePropositionFoundationText2
            valuePropositionFoundationLinkFinland
            valuePropositionFoundationLinkSweden
            valuePropositionPartnersTitle
            valuePropositionPartnersText1
            valuePropositionPartnersText2
            valuePropositionPartnersText3
            valuePropositionPartnersButton
            credibilityTitle
            credibilitySubtitle
            credibilityMedia1Publisher
            credibilityMedia1Title
            credibilityMedia1Url
            credibilityMedia2Publisher
            credibilityMedia2Title
            credibilityMedia2Url
            credibilityMedia3Publisher
            credibilityMedia3Title
            credibilityMedia3Url
            credibilityMedia4Publisher
            credibilityMedia4Title
            credibilityMedia4Url
            solutionsTitle
            solutions1Name
            solutions1Description
            solutions2Name
            solutions2Description
            solutions3Name
            solutions3Description
            solutionsReadMore
            segmentsHeading
            segmentsSubeading
            segmentsWorkHeading
            segmentsWorkSubheading
            segmentsWorkDescription
            segmentsWorkPrelink
            segmentsWorkLink
            segmentsWorkLinkText
            segmentsSchoolsHeading
            segmentsSchoolsSubheading
            segmentsSchoolsDescription
            segmentsSchoolsPrelink
            segmentsSchoolsLink1
            segmentsSchoolsLink1Text
            segmentsSchoolsLink2
            segmentsSchoolsLink2Text
            segmentsPersonalHeading
            segmentsPersonalSubheading
            segmentsPersonalDescription
            segmentsPersonalPrelink
            segmentsPersonalLink1
            segmentsPersonalLink2
            segmentsProHeading
            segmentsProSubeading
            segmentsProWorkHeading
            segmentsProWorkSubheading
            segmentsProWorkDescription
            segmentsProWorkPrelink
            segmentsProWorkLink
            segmentsProWorkLinkText
            segmentsProSchoolsHeading
            segmentsProSchoolsSubheading
            segmentsProSchoolsDescription
            segmentsProSchoolsPrelink
            segmentsProSchoolsLink1
            segmentsProSchoolsLink1Text
            segmentsProSchoolsLink2
            segmentsProSchoolsLink2Text
            segmentsProPersonalHeading
            segmentsProPersonalSubheading
            segmentsProPersonalDescription
            segmentsProPersonalPrelink
            segmentsProPersonalLink1
            segmentsProPersonalLink2
            companyMissionHeading
            companyMissionDescription
            companyMissionLarge
            companyExpertiseHeading
            companyExpertiseDescription
            companyExpertiseLink1
            companyExpertiseLink2
            companyAiHeading
            companyAiDescription
            companyFact1Large
            companyFact1Small
            companyFact2Large
            companyFact2Small
            companyFact3Large
            companyFact3Small
            companyFact4Large
            companyFact4Small
            companyFact5Large
            companyFact5Small
            companyFact6Large
            companyFact6Small
            contactFormHeading
            contactFormCountry
            contactFormOffice
            contactFormChat
            contactFormName
            contactFormEmail
            contactFormPhone
            contactFormMessage
            contactFormButtonSubmit
            contactFormSuccess
            contactFormError
            contactFormErrorContact
            protectionEnPreventShort
            protectionEnPreventLong
            protectionEnPreventContactName
            protectionEnPreventContactPosition
            protectionEnPreventContactEmail
            protectionEnProtectShort
            protectionEnProtectLong
            protectionEnProtectContactName
            protectionEnProtectContactPosition
            protectionEnProtectContactEmail
            protectionEnImpactShort
            protectionEnImpactLong
            protectionEnImpactContactName
            protectionEnImpactContactPosition
            protectionEnImpactContactEmail
            protectionEnPreventHighlight
            protectionEnProtectHighlight
            protectionEnImpactHighlight
            protectionEnTitle
            mediaSectionEnButton
            mediaSectionEnTitle
            contactFormEnHeading
            contactFormEnOffice
            contactFormEnCountry
            contactFormEnName
            contactFormEnEmail
            contactFormEnPhone
            contactFormEnMessage
            contactFormEnButtonSubmit
            contactFormEnSuccess
            contactFormEnError
            contactFormEnErrorContact
            proWebinarTitle
            sharePage
            checkPage
            footerOperatorLabel
            footerBusinessIdLabel
            footerBranchLabel
            footerRightsReserved
            proWebinarRecordingHeading
            proWebinarRecordingSubHeading
            proWebinarRecordingDescription
            proWebinarRecordingUrl
            formFieldName
            formFieldEmail
            formFieldJobTitle
            formFieldCity
            formFieldSchool
            formFieldSchoolLevel
            formFieldDate
            formFieldMessage
            formFieldOrganization
            formFieldQuantity
            formFieldOnlineAttendance
            formFieldPhone
            formFieldCertificate
            formFieldLunch
            formFieldLunchDescription
            formFieldSometurvaUsage
            formFieldSometurvaUsageOption1
            formFieldSometurvaUsageOption2
            formFieldSometurvaUsageOption3
            formButtonSubmit
            formErrorGeneral
            formErrorUserExist
            formErrorContactUs
            formSuccess
            formMoreInfo
            formAdditionalValue
            formRequired
            proWebinarFormJobOptions
            proWebinarFormButton
            proWebinarFormErrorUserExist
            schoolsTrainingQuestionsTitle
            schoolsTrainingQuestionsText1
            schoolsTrainingQuestionsText2
            schoolsTrainingQuestionsText3
            schoolsTrainingQuestionsText4
            schoolsTrainingQuestionsText5
            schoolsTrainingQuestionsText6
            schoolsTrainingOverviewText1
            schoolsTrainingOverviewText2
            schoolsTrainingOverviewLinkText
            schoolsTrainingOverviewText3
            schoolsTrainingHeroTitle
            schoolsTrainingHeroDescription
            webinarHeroButton
            schoolsTrainingHeroList
            schoolsTrainingListShowAll
            schoolsTrainingListShowLess
            schoolsTrainingNewsletter
            webinarPrivacyPolicy
            webinarFormSuccessTitle
            webinarFormSuccessBody
            webinarFormSuccessButton
            trainingFormSuccessBody
            trainingFormSpam
            trainingLiveLink1
            trainingLiveLink2
            trainingSuccess1
            trainingSuccess2
            trainingSuccess3
            addToCalendarTitle
            addToCalendarGoogle
            addToCalendarOutlook
            addToCalendarICS
            materialsPdfLinkText
            otherSectionMaterial1PdfLinkText
            materialsOtherTitle
            otherSectionMaterial1Pdf
            otherSectionMaterial1Title
            otherSectionMaterial1Description
            materialsTitle
            materialsDescription
            materialsIntro1
            materialsIntro2
            materialsIntro3
            materialsIntro4
            materialsIntroLink
            materialsCuricculumTitle
            materialsCuricculum1
            materialsCuricculum2
            materialsCuricculum3
            materialsCuricculum4
            materialsCuricculum5
            materialsCuricculum6
            materialsCuricculum7
            materialsCuricculum8
            materialsCuricculum9
            materialsCTA1Title
            materialsCTA1Description
            publishSoon
            videoDuration
            proCoursesHeroTitle1
            proCoursesHeroDescription
            proCoachTitle
            proCoach1Name
            proCoach1Position
            proCoach1Title
            proCoach2Name
            proCoach2Position
            proCoach2Title
            proCoach3Name
            proCoach3Position
            proCoach3Title
            proCoursesInfo1Title
            proCoursesInfo1Highlights
            proCoursesInfo1Description1
            proCoursesInfo1Description2
            proCoursesProblemsTitle
            proCoursesProblemsList
            proCoursesSolutionsHeading
            proCoursesSolutionsSubheading
            proCoursesSolutionsIncluded
            proCoursesSolutions1Segment
            proCoursesSolutions1Name
            proCoursesSolutions1Features
            proCoursesSolutions1Effects
            proCoursesSolutions2Segment
            proCoursesSolutions2Name
            proCoursesSolutions2Features
            proCoursesSolutions2Effects
            proCoursesSolutions3Segment
            proCoursesSolutions3Name
            proCoursesSolutions3Features
            proCoursesSolutions3Effects
            proCoursesSolutionsPoint1Title
            proCoursesSolutionsPoint1Description
            proCoursesSolutionsPoint2Title
            proCoursesSolutionsPoint2Description
            proCoursesSolutionsPoint3Title
            proCoursesSolutionsPoint3Description
            quotesTitle
            quoteMore
            newsletterFormSuccessTitle
            newsletterFormSuccessBody
            onboardingHeroTitle
            onboardingHeroDescription
            onboardingVideoTItle
            onboardingVideoDescription1
            onboardingVideoDescription2
            onboardingVideoDescription3
            onboardingIntroTitle
            onboardingIntroDescription1
            onboardingIntroDescription2
            onboardingSection1Title
            onboardingSection2Title
            onboardingSection3Title
            onboardingSection4Title
            onboardingSection5Title
            onboardingFeature1Title
            onboardingFeature1Description
            onboardingFeature2Title
            onboardingFeature2Description
            onboardingFeature3Title
            onboardingFeature3Description
            onboardingSituationsDescription1
            onboardingSituationsList1
            onboardingSituationsList2
            onboardingSituationsList3
            onboardingSituationsList4
            onboardingSituationsList5
            onboardingSituationsList6
            onboardingSituationsList7
            onboardingSituationsList8
            onboardingSituationsList9
            onboardingSituationsDescription2
            onboardingDeployDescription
            onboardingDeployStep1Title
            onboardingDeployStep1Item1
            onboardingDeployStep1Item2
            onboardingDeployStep1Item3
            onboardingDeployStep1Item4
            onboardingDeployStep1Item5
            onboardingDeployStep1Item6
            onboardingDeployStep2Title
            onboardingDeployStep2Description
            onboardingDeployStep3Title
            onboardingDeployStep3Description
            onboardingFaq1Question
            onboardingFaq1Answer1
            onboardingFaq1Answer2
            onboardingFaq1AnswerList1
            onboardingFaq1AnswerList2
            onboardingFaq1AnswerList3
            onboardingFaq1AnswerList4
            onboardingFaq1AnswerList5
            onboardingFaq2Question
            onboardingFaq2Answer1
            onboardingFaq2Answer2
            onboardingFaq3Question
            onboardingFaq3Answer1
            onboardingFaq3Answer2
            onboardingFaq4Question
            onboardingFaq4Answer1
            onboardingFaq4Answer2
            onboardingFaq4Answer3
            schoolOnboardingHeroTitle
            schoolOnboardingHeroDescription
            schoolOnboardingVideoDescription1
            schoolOnboardingVideoDescription2
            schoolOnboardingVideoTitle
            schoolOnboardingVideoLink
            schoolOnboardingSection1Title
            schoolOnboardingSection2Title
            schoolOnboardingSection3Title
            schoolOnboardingSection4Title
            schoolOnboardingSection5Title
            schoolOnboardingFeature1Title
            schoolOnboardingFeature1Description
            schoolOnboardingFeature2Title
            schoolOnboardingFeature2Description
            schoolOnboardingFeature3Title
            schoolOnboardingFeature3Description
            schoolOnboardingFeature4Title
            schoolOnboardingFeature4Description
            schoolOnboardingSection2Title
            schoolOnboardingSituationsDescription1
            schoolOnboardingSituationsList1
            schoolOnboardingSituationsList2
            schoolOnboardingSituationsList3
            schoolOnboardingSituationsList4
            schoolOnboardingSituationsList5
            schoolOnboardingSituationsList6
            schoolOnboardingSituationsList7
            schoolOnboardingSituationsList8
            schoolOnboardingSituationsList9
            schoolOnboardingSituationsDescription2
            schoolOnboardingHowDoWeHelpDescription
            schoolOnboardingHelpListItem1
            schoolOnboardingHelpListItem2
            schoolOnboardingHelpListItem3
            schoolOnboardingHelpListItem4
            schoolOnboardingHelpListItem5
            schoolOnboardingHelpListItem6
            schoolTrainingThemesTitle
            schoolTrainingThemesList
            schoolsTrainingDescriptionTitle
            schoolsTrainingInfo1Highlights
            schoolsTrainingDescriptionText1
            schoolsTrainingDescriptionText2
            schoolsTrainingDescriptionTextBold
            schoolsTrainingDescriptionText4
            schoolOnboardingHelpQuote1
            schoolOnboardingHelpQuote2
            schoolOnboardingFaq1Question
            schoolOnboardingFaq1Answer
            schoolOnboardingFaq2Question
            schoolOnboardingFaq2Answer1
            schoolOnboardingFaq2Answer2
            schoolOnboardingFaq2AnswerLinkUrl
            schoolOnboardingFaq2AnswerLinkText
            schoolOnboardingFaq3Question
            schoolOnboardingFaq3Answer
            schoolOnboardingFaq4Question
            schoolOnboardingFaq4Answer1
            schoolOnboardingFaq4Answer2
            schoolOnboardingFaq4Answer3
            schoolOnboardingFaq4Answer4
            schoolOnboardingFaq4Answer3LinkUrl
            schoolOnboardingFaq4Answer3LinkText
            schoolOnboardingFaq5Question
            schoolOnboardingFaq5Answer
            onboardingFaq4Answer3Part1
            onboardingFaq4Answer3Part2
            onboardingFaq4Answer3LinkText
            report2022DownloadTitle
            report2022DownloadDescription
            report2022DownloadDescriptionShort
            report2023DownloadTitle
            report2023DownloadDescription
            report2023DownloadDescriptionShort
            report2024DownloadTitle
            report2024DownloadDescription
            report2024DownloadDescriptionShort
            reportsHeroTitle
            reportsDownloadDescription
            reportDownloadButton
            reportsDownloadButton
            report2025HeroTitle
            report2025HeroDescription
            report2025HeroAvailabilityNote
            report2025HeroStartButton
            report2025HomepageSectionTitle
            report2025HomepageSectionDescription
            report2025HomepageSectionCta
            report2025HeroOlderReportsButton
            report2025 {
              localeNote
              startCoverCta
              readOlderReports
              title
              subtitle
              reportHeroDescription
              forewordHeading
              forewordParagraphs
              forewordAuthorName
              forewordAuthorTitle
              boySectionHeading
              boySectionText1
              boySectionText2
              boySectionText2Highlight
              boySectionOverlayText
              ageDistributionHeading
              ageDistributionText
              ageDistributionText2
              ageDistributionText2Highlight
              aiSectionHeading
              aiSectionText1
              aiSectionText2
              aiCaseTiles {
                tooltipTitle
                tooltipQuote
                tooltipAttribution
                tooltipDisclaimer
              }
              crimeTagsBoxTitle
              crimeTagsBoxIndexNote
              crimeTagsBoxClickHint
              crimeTagLabelDefamation
              crimeTagLabelSexualCrimes
              crimeTagLabelIllegalThreat
              crimeTagTooltipDefamation
              crimeTagTooltipSexualCrimes
              crimeTagTooltipIllegalThreat
              psychologicalSymptomsBarTitle
              psychologicalSymptomsBarLabelAnxious
              psychologicalSymptomsBarLabelLowMood
              psychologicalSymptomsBarLabelAngry
              psychologicalSymptomsBarLabelHumiliated
              psychologicalSymptomsBarLabelWorthless
              psychologicalSymptomsBarLabelDailyDifficulties
              psychologicalSymptomsBarLabelSelfHarmThoughts
              psychologicalSymptomsBarLabelSleepDifficulties
              psychologicalImpactHeading
              psychologicalImpactFootnote
              psychologicalImpactText
              psychologicalImpactTextHighlight
              seriousCasesHeading
              seriousCasesText
              seriousCasesTextHighlight
              seriousCasesPieTitle
              seriousCasesPieLabelCrime
              seriousCasesPieLabelThreatOfCrime
              seriousCasesPieLabelNoCrime
              sexualCrimesHeading
              sexualCrimesText
              sexualCrimesText2
              sexualCrimesText2Highlight
              phoneBansHeading
              perpetratorKnownHeading
              perpetratorKnownText
              perpetratorKnownTextHighlight
              perpetratorKnownPieTitle
              perpetratorKnownPieLabelFromSchool
              perpetratorKnownPieLabelFromElsewhere
              perpetratorKnownPieLabelFromFriendCircles
              phoneBansText
              phoneBansText2
              phoneBansText3
              teacherSectionHeading
              teacherSectionText
              teacherSectionText2
              teacherSectionText3
              teacherSectionText2Source {
                label
              }
              teacherCasesPieTitle
              teacherCasesPieLabelOwnSituation
              teacherCasesPieLabelStudentSituation
              casesCountLabel
              solvedCasesChartTitle
              trustedFlaggerHeading
              trustedFlaggerText
              trustedFlaggerTextHighlight
              trustedFlaggerText2
              preventionHeading
              preventionText
              preventionText2
              preventionText2Highlight
              specializedExpertiseHeading
              toldAdultPieTitle
              toldAdultPieLabelYes
              toldAdultPieLabelNo
              toldAdultPieLabelUnknown
              specializedExpertiseText1
              specializedExpertiseText2
              feedbackHeading
              feedbackText
              feedbackText2
              feedbackPlaceholderQuotes {
                quote
              }
              journeyHeading
              journeyIntro
              journeyClickHint
              journeyVisualStart
              journeyVisualStartDetail
              journeyVisualStartExample
              journeyVisualStartSource {
                label
              }
              journeyVisualLeftLabel
              journeyVisualLeftSteps {
                title
                description
                tooltip
                example
              }
              journeyVisualRightLabel
              journeyVisualRightSteps {
                title
                description
                tooltip
                example
              }
              expansionHeading
              expansionText
              supportHeading
              supportText
              supportText2
              dataIndexHeading
              dataIndexText
              dataIndexText2
              navPhenomena
              navSchoolSupport
              navSolutions
              navPrevention
              ageChartTitle
              ageChartShowYearAriaPrefix
              ageChartTooltipLabel
              ageChartTooltipValueLabel
              ageChartXAxisLabel
              ageChartYAxisLabel
              platformRisksHeading
              platformRisksText
              platformInfoAriaSuffix
              closeLabel
              infoLabel
              socialPlatformSectionTitle
              socialPlatformClickHint
              socialPlatformNote
              socialPlatformDrawerTexts {
                snapchat {
                  name
                  stats
                  risksDescription
                  extraStats
                }
                tiktok {
                  name
                  stats
                  risksDescription
                  extraStats
                }
                whatsapp {
                  name
                  stats
                  risksDescription
                  extraStats
                }
                other {
                  name
                  stats
                  risksDescription
                }
                instagram {
                  name
                  stats
                  risksDescription
                  extraStats
                }
                games {
                  name
                  stats
                  risksDescription
                  extraStats
                }
                discord {
                  name
                  stats
                  risksDescription
                  extraStats
                }
              }
              aiCaseClickHint
              aiCaseOpenAriaSuffix
              aiCaseDialogAriaLabel
              sourceFallbackStt
              teacherSectionText2Highlight
              supportTextHighlight
              feedbackTextHighlight
              specializedExpertiseText1Highlight
              preventionText2HighlightCustom
              dataIndexText2HighlightCustom
              expansionClickHint
              swedenHotspotsImageAlt
              swedenHotspots {
                label
                text
              }
              contactHeading
              contactDescription
              contactDescriptionSubheading
              contactDescriptionSecond
            }
            formFieldEntityTitle
            allLanguages
            specialWebinarTitle
            specialWebinarDescription
            specialWebinarBadge1
            specialWebinarBadge2
            aboutUsStats1Text1
            aboutUsStats1Text2
            aboutUsStats1Text3
            aboutUsStats2Text1
            aboutUsStats2Text2
            aboutUsStats2Text3
            aboutUsTimeline1
            aboutUsTimeline2
            aboutUsTimeline3
            aboutUsTimeline4
            aboutUsVideoTitle
            aboutUsVideo1Link
            aboutUsVideo2Link
            aboutUsVideoContent1
            aboutUsVideoContent2
            aboutUsStoryTitle
            aboutUsStoryContent1
            aboutUsStoryContent2
            aboutUsCommunitiesTitle
            aboutUsCommunitiesContent
            aboutUsVisionTitle
            aboutUsVisionContent1
            aboutUsVisionContent2
            aboutUsVisionContent3
            aboutUsSecurityTitle
            aboutUsSecurityContent1
            aboutUsSecurityContent2
            aboutUsTeamTitle
            aboutUsTeamSubtitle
            aboutUsTeamContent1
            aboutUsTeamLink1
            aboutUsTeamLink2
            aboutUsSomebuddyTitle
            aboutUsSomebuddyText1
            aboutUsSomebuddyText2
            waitingListTitle
            waitingListSubtitle
            waitingListButton
            waitingListSuccessTitle
            waitingListSuccessBody
            waitingListSuccessButton
            trustedFlaggerTitle
            trustedFlaggerDescription
            trustedFlaggerReport2024
            trustedFlaggerReport2025
            ukSchoolsSeoTitle
            ukSchoolsHeroTitle
            ukSchoolsHeroHighlight
            ukSchoolsHeroDescription
            ukSchoolsHeroButton
            ukSchoolsProblemTitle
            ukSchoolsProblemLead
            ukSchoolsProblemItems
            ukSchoolsJourneyTitle
            ukSchoolsJourneyLead
            ukSchoolsJourneyItems
            ukSchoolsCurriculumTitle
            ukSchoolsCurriculumLead
            ukSchoolsCurriculumNote
            ukSchoolsWallTitle
            ukSchoolsWallLead
            ukSchoolsWallItems
            ukSchoolsResponseTitle
            ukSchoolsResponseLead
            ukSchoolsResponseNames
            ukSchoolsResponseDescriptions
            ukSchoolsAlongsideTitle
            ukSchoolsAlongsideBody
            ukSchoolsPilotTitle
            ukSchoolsPilotLead
            ukSchoolsPilotIncluded
            ukSchoolsPilotAskTitle
            ukSchoolsPilotAsk
            ukSchoolsPilotPricingNote
            ukSchoolsFaqTitle
            ukSchoolsFaqQuestions
            ukSchoolsFaqAnswers
            ukSchoolsFormTitle
            ukSchoolsFormLead
            ukSchoolsFormSchool
            ukSchoolsFormRole
            ukSchoolsFormRoleOptions
            ukSchoolsFormButton
            ukSchoolsFormSuccess
            ukSchoolsFormSuccessBody
            ukSchoolsVideoId
            ukSchoolsVideoTitle
            ukSchoolsVideoPoints
            ukSchoolsThreatsTitle
            ukSchoolsThreatsLead
            ukSchoolsThreatsItems
            ukSchoolsThreatsClosing
            ukSchoolsThreatsStatValues
            ukSchoolsThreatsStatLabels
            ukSchoolsThreatsStatNote
            ukSchoolsCarouselTitle
            ukSchoolsCarouselLead
            ukSchoolsCarouselNames
            ukSchoolsCarouselTexts
            ukSchoolsAgeDistributionText
            ukSchoolsTestimonialsTitle
            ukSchoolsTestimonialQuotes
            ukSchoolsTestimonialAuthors
            ukSchoolsIntegrationsTitle
            ukSchoolsIntegrationsText
            ukSchoolsCtaTitle
            ukSchoolsCtaLead
            ukSchoolsCtaActionTitle
            ukSchoolsCtaItems
            ukSchoolsTrialTitle
            ukSchoolsTrialLead
            ukSchoolsCtaButton
            ukSchoolsBookerTitle
            ukSchoolsBookerLead
          }
        }
      }
    }
  }
`

const useTranslations = (forcedLocale = null) => {
  // Grab the locale (passed through context) from the Context Provider
  const { locale } = useContext(LocaleContext)
  // Query the JSON files in <rootDir>/i18n/translations
  const { rawData } = useStaticQuery(query)

  // Simplify the response from GraphQL
  const simplified = rawData.edges.map((item) => {
    return {
      name: item.node.name,
      translations: item.node.translations,
    }
  })

  const { translations } = simplified.filter(
    (lang) => lang.name === `${forcedLocale || locale}-default`,
  )[0]

  return translations
}

export default useTranslations
